import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " ID ", -1 /* HOISTED */)
const _hoisted_6 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_7 = { class: "linked" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <div class=\"card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25\">\n      <div class=\"d-sm-flex align-items-center\">\n        <router-link to=\"/create-consent\"\n          class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none\">\n          {{ $t('cta.create_consent') }}\n          <i class=\"ph-bold ph-plus position-relative ms-5 fs-12\"></i>\n        </router-link>\n      </div>\n    </div> "),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.consents === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_5,
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('form.title.label')), 1 /* TEXT */),
                    _createCommentVNode(" <th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0\">\n              </th> ")
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_7, [
                  _createCommentVNode(" CENTER ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (consent) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: consent.id
                    }, [
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-primary",
                        onClick: ($event: any) => (_ctx.show(consent))
                      }, _toDisplayString(consent.id), 9 /* TEXT, PROPS */, _hoisted_8),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        onClick: ($event: any) => (_ctx.show(consent))
                      }, _toDisplayString(consent.current_version?.title ?? consent.title), 9 /* TEXT, PROPS */, _hoisted_9),
                      _createCommentVNode(" <td class=\"shadow-none lh-1 fw-medium text-body-tertiary text-end\">\n                <div class=\"dropdown position-static\">\n                  <button class=\"dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition\" type=\"button\"\n                    data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-bs-boundary=\"viewport\">\n                    <i class=\"flaticon-dots\"></i>\n                  </button>\n                  <ul class=\"dropdown-menu\">\n                    <li>\n                      <router-link :to=\"{ path: `/consent/${consent.id}` }\"\n                        class=\"dropdown-item d-flex align-items-center\">\n                        <i class=\"ph-duotone ph-pencil lh-1 me-8 position-relative top-1\"></i>\n                        {{ $t('cta.edit') }}\n                      </router-link>\n                    </li>\n                    <li>\n                      <button class=\"dropdown-item d-flex align-items-center\" v-on:click=\"confirmDeleteConsent(consent)\">\n                        <i class=\"ph ph-trash lh-1 me-8 position-relative top-1\"></i>\n                        {{ $t('cta.delete') }}\n                      </button>\n                    </li>\n                  </ul>\n                </div>\n              </td> ")
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])),
        _createCommentVNode(" PAGINATION "),
        _createCommentVNode(" <TablePagination :count=\"consents?.length ?? 0\" :page=\"currentPage\" :total=\"total\" :pages=\"lastPage\"\n        @change=\"setPage($event)\" /> ")
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteConsent())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}